/**
 * Data object representing the firmware list item
 * @note This is usually used in data table as a row. Params don't have default values since this data object is used to
 * represent data that actually exists.
 */
export class FirmwareListItemDataObject {
	/**
	 * @param {string} id - List item's ID.
	 * @param {string} deviceType - List item's device type.
	 * @param {string} version - List item's version.
	 * @param {Date} releaseDate - List item's release date.
	 */
	constructor(id, deviceType, version, releaseDate) {
		this.id = id;
		this.deviceType = deviceType;
		this.version = version;
		this.releaseDate = releaseDate;
	}
}

/**
 * Data object representing the firmware item
 * @note This is usually used when creating or updating data table item using a popup or a dialog. Params have default 
 * values since this data object can be used for creating an item. This is why 'id' has a default value of null which 
 * represents a new item that is being created.
 */
export class FirmwareItemDataObject {
	/**
	 * @param {string|null} [id=null] - Item's ID.
	 * @param {string} [deviceType=''] - Item's device type.
	 * @param {string} [version=''] - Item's version.
	 * @param {Date} [releaseDate=null] - Item's release date.
	 * @param {FormData} [firmwareFormData=null] - Selected firmware file.
	 */
	constructor(id, deviceType = '', version = '', releaseDate = null, firmwareFormData = null) {
		this.id = id;
		this.deviceType = deviceType;
		this.version = version;
		this.releaseDate = releaseDate;
		
		// File write properties
		// @desc Properties used to store selected file(s) that will be saved in the database.
		this.firmwareFormData = firmwareFormData;
	}
}